import { useEffect, useRef } from 'react'
import { useTonWallet } from '@tonconnect/ui-react'
import { useAppContext } from '../contexts/App.context'
import { useTonProofAuth } from './useTonProofAuth'

export function useWalletConnection(): void {
  const wallet = useTonWallet()
  const { setReferralKey } = useAppContext()
  const previousWalletRef = useRef<string | null>(null)
  const { isAuthenticated, authError } = useTonProofAuth()

  useEffect(() => {
    const walletAddress = wallet?.account.address

    if (walletAddress && walletAddress !== previousWalletRef.current) {
      console.log('Authentication: Wallet connected:', walletAddress)
      previousWalletRef.current = walletAddress
      // User creation is now handled by backend in checkProof flow
    } else if (!walletAddress) {
      previousWalletRef.current = null
      // Clear referral key when wallet is disconnected
      setReferralKey(null)
    }
  }, [wallet?.account.address, setReferralKey])

  // Log authentication errors if any
  useEffect(() => {
    if (authError) {
      console.error('Authentication: Authentication error:', authError)
    }
  }, [authError])

  // Log authentication status
  useEffect(() => {
    if (wallet?.account.address) {
      console.log(
        'Authentication: Authentication status:',
        isAuthenticated ? 'authenticated' : 'not authenticated',
      )
    }
  }, [isAuthenticated, wallet?.account.address])
}
